import { call, put, takeLatest } from "redux-saga/effects";
import { subsidiariesAPI } from "../api/api";
import { SubsidiariesActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* saveSubsidiaryLogo(action) {
    try {
        yield call(() =>
            subsidiariesAPI.editLogo(
                action.payload.subsidiary.id,
                action.payload.subsidiary.logo
            )
        );

        yield put({
            type: SubsidiariesActionTypes.SAVE_SUBSIDIARY_LOGO_SUCCESS
        });
        yield put({
            type: SubsidiariesActionTypes.GET_SUBSIDIARIES
        });
    } catch (e) {
        API.handleError(e.response, "Error saving subsidiary logo.");

        yield put({
            type: SubsidiariesActionTypes.SAVE_SUBSIDIARY_LOGO_FAIL,
            message: e.message
        });
    }
}

export function* saveSubsidiaryLogoWatcher() {
    yield takeLatest(
        SubsidiariesActionTypes.SAVE_SUBSIDIARY_LOGO,
        saveSubsidiaryLogo
    );
}
